import PropTypes from "prop-types";
import React from "react";
import "./styles.css";

const TextBanner = ({
  childTitle,
  childContent,
  rightChildTitle,
  rightChildContent
}) => (
  <div className="text-hero">
    <div className="container">
      <div className="text-container">
        <span className="title-h1">{childTitle}</span>
        <p>{childContent}</p>
      </div>
    </div>
    <div className="corner" />
    <div className="right-text-container">
      <p>{rightChildTitle}</p>
      <p className="larger">{rightChildContent}</p>
    </div>
  </div>
);

TextBanner.propTypes = {
  childTitle: PropTypes.node,
  childContent: PropTypes.node
};

TextBanner.defaultProps = {
  childTitle: "Title",
  childContent: null
};

TextBanner.propTypes = {
  rightChildTitle: PropTypes.node,
  rightChildContent: PropTypes.node
};

TextBanner.defaultProps = {
  rightChildTitle: null,
  rightChildContent: null
};

const TextHero = TextBanner;

export default TextHero;



// WEBPACK FOOTER //
// ./src/components/TextBanner/index.jsx